import createAccordion from "@/lib/accordion";

export default function (element, dataset) {
  const items = element.querySelectorAll(".at_item_wrap");
  const accordion = createAccordion(items);

  items.forEach((e) => {
    e.addEventListener("click", () => {
      if (e.getAttribute("style").includes("auto")) return;
      accordion.closeAll();
      accordion.open(e);
    });
  });
}
